import { ETypeSubstrat } from '../domain/IBGN/enum/type-substrat';
import { PrelevementVitesse } from '../domain/Shared/prelevement-vitesse';
import { Prelevement } from '../domain/Shared/prelevement';
import { Substrat } from '../domain/IBGN/substrat';

export class SampleTakingModel {

    /**
     * MPCE OR IBGN MERGED
     */
    Type: number;
    Pourcentage: number;
    Presence: boolean;
    /**
     * For calculation
     */
    TmpPourcentage: number;
    PrelevementVitesses: PrelevementVitesse[] = [];
    // PrelevementList: PrelevementVitesse[] = [];
}
